// Timout expressed milliseconds
export const TIMEOUT_STARTSTOP = 15000;
export const TIMEOUT_DISCOVER = 30000;

export const SELECT_TAGS_RESOURCES = {
    active:  'active',
    stopped: 'stopped'
};


const STATUS_RESOURCE_TERMINATED = '0';
const STATUS_RESOURCE_ACTIVE = '1';
const STATUS_RESOURCE_STOPPED = '2';
const STATUS_RESOURCE_UNKNOWN = '3';
const STATUS_RESOURCE_PENDING = '4';
const STATUS_RESOURCE_WARNING = '5';

export const STATUS_RESOURCE = {
    STATUS_RESOURCE_TERMINATED,
    STATUS_RESOURCE_ACTIVE,
    STATUS_RESOURCE_STOPPED,
    STATUS_RESOURCE_UNKNOWN,
    STATUS_RESOURCE_PENDING,
    STATUS_RESOURCE_WARNING
};

const STATUS_QUEUED = 1;
const STATUS_LAUNCHED = 2;
const STATUS_SUCCESS = 3;
const STATUS_FAIL = 4;
const STATUS_UNKNOWN = 5;
const STATUS_AWS_FAILED = 6;
const STATUS_AZURE_FAILED = 7;
const STATUS_VCLOUD_FAILED = 8;

export const STATUS_OPERATION_DISCOVERY = {
    STATUS_QUEUED,
    STATUS_LAUNCHED,
    STATUS_SUCCESS,
    STATUS_FAIL,
    STATUS_UNKNOWN,
    STATUS_AWS_FAILED,
    STATUS_AZURE_FAILED,
    STATUS_VCLOUD_FAILED
};



// WEBPACK FOOTER //
// ./src/config/constants/infrastructureResources.js